import { enNZ } from "../../../../date-fns/locale/en-NZ.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    enNZ
  }
};